import { RefreshCw } from 'lucide-react';

import { Button } from '../shadcn/button';

interface ErrorFallbackProps {
  error?: Error;
  reset?: () => void;
  title?: string;
  description?: string;
  buttonLabel?: React.ReactNode;
}

export function ErrorFallback({
  error,
  reset,
  title = 'Something went wrong',
  buttonLabel = (
    <>
      <RefreshCw className="h-4 w-4" />
      Try Again
    </>
  ),
  description = 'We encountered an error while loading this page. Please try again or contact support if the problem persists.',
}: ErrorFallbackProps) {
  return (
    <div className="flex flex-col items-center justify-center px-6 py-12">
      <div className="text-destructive mb-4">
        <svg
          className="mx-auto mb-4 h-12 w-12"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1.5}
            d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z"
          />
        </svg>
      </div>

      <h3 className="text-foreground mb-2 text-lg font-semibold">{title}</h3>

      <p className="text-muted-foreground mb-6 max-w-md text-center text-sm">{description}</p>

      <div className="flex flex-col items-center space-y-3">
        {reset && (
          <Button onClick={reset} className="flex items-center gap-2">
            {buttonLabel}
          </Button>
        )}
        {error?.message && (
          <details className="mt-4">
            <summary className="text-muted-foreground hover:text-foreground cursor-pointer text-xs">
              Technical Details
            </summary>
            <div className="bg-muted text-muted-foreground mt-2 rounded-md p-3 font-mono text-xs">
              {error.message}
            </div>
          </details>
        )}
      </div>
    </div>
  );
}
